import { render, staticRenderFns } from "./sfc-menu-mobile-v2.vue?vue&type=template&id=58c477e0&scoped=true&lang=pug&"
import script from "./sfc-menu-mobile-v2.vue?vue&type=script&lang=js&"
export * from "./sfc-menu-mobile-v2.vue?vue&type=script&lang=js&"
import style0 from "./sfc-menu-mobile-v2.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./sfc-menu-mobile-v2.vue?vue&type=style&index=1&id=58c477e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c477e0",
  null
  
)

export default component.exports